import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { NumberFormat } from "../../common/helpers";
import API from "../../common/API";
import { parsedUser } from "../../common/GetCurrentUser";
import moment from "moment";

const QuickAddEditFranchise = (props) => {
  const user = parsedUser();

  const [isLoading, setIsLoading] = useState(false);
  const [records, setRecords] = useState<any[]>([]);
  const [currentDate, setCurrentDate] = useState(new Date());

  const [totalSummary, setTotalSummary] = useState(0);
  const bindRemote = async () => {
    let request = await API.getAction(
      `franchise/byDate?organization=${user.OrganizationId}&date=${moment(currentDate).format("YYYY-MM-DD")}`
    );
    console.log(request);
    if (request.data.status === "ok") {
      setRecords(request.data.response);
    }
  };

  const handleSubmitBatch = async (obj) => {
    try {
      console.log(records);
      setIsLoading(true);
      let request = await API.postAction(`franchise/historyAddEdit`, records);

      console.log("response from adding", request);
      if (request.status === 200) {
        await bindRemote();
      }
    } catch (e) {
      console.error(e);
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    bindRemote();
  }, [currentDate]);

  useEffect(() => {
    console.log("records update", records);
    let summary = 0;
    records.forEach((item: any) => {
      summary += item.value ?? 0;
    });
    setTotalSummary(summary);
  }, [records]);

  return (
    <>
      <Card className="shadow-sm my-4 bg-white">
        <Card.Header className="px-4 py-2">
          <Card.Title className="d-inline">Historico de Franquicias</Card.Title>
          <input type="date" className="form-control d-inline w-auto ms-2" value={moment(currentDate).format("YYYY-MM-DD")} onChange={(e) => setCurrentDate(new Date(e.target.value))} />
        </Card.Header>
        <Card.Body className="px-0 py-2">
          <table className="table table-striped ">
            <thead>
              <tr>
                <th>Nombre</th>
                <th className="text-center bg-primary text-white">Volumen</th>

              </tr>
            </thead>
            <tbody>
              {records && Array.isArray(records) && records.map((item, index) => {
                console.log(item);
                let record: any = item;

                return (
                  <tr key={index}>
                    {/* <td>30,000 gl</td> */}
                    <td

                    >
                      {record.franchiseName}

                    </td>
                    <td className="text-center bg-secondary px-1">
                      <input
                        type="number"
                        className="form-control"
                        name="value"
                        onChange={(e: any) => {
                          record.value = e.target.value * 1;
                          //   handleChange(index, record);
                          setRecords([
                            ...records.slice(0, index),
                            record,
                            ...records.slice(index + 1),
                          ]);
                        }}
                        step={0.01}
                        min={0}
                        value={record.value ?? ""}
                      ></input>
                    </td>

                  </tr>
                );
              })}
            </tbody>

          </table>
        </Card.Body>
        <Card.Footer className="px-4 py-2">
          <Row>
            <Col className="text-uppercase">
              Total: <b>{NumberFormat(totalSummary)} gl</b>
            </Col>
            <Col className="text-end">
              <button
                className="btn btn-primary btn-sm"
                type="button"
                disabled={isLoading}
                onClick={() => handleSubmitBatch(null)}
              >
                {isLoading ? (
                  <i className="fa fa-spinner fa-spin me-2"></i>
                ) : null}
                Guardar
              </button>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default QuickAddEditFranchise;
